import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import ManageHospitalListChild from "./ManageHospitalListChild";

const ManageHospitalList = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ManageHospitalListChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ManageHospitalList;
